import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { isMarketingPath } from "./utils/marketingPaths";

// Only initialize Sentry if not on localhost
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "";

// Load Sentry lazily, after the app has rendered and the browser is idle, so
// the monitoring SDK (and its session-replay integration) stays off the
// initial critical path and out of the entry bundle.
const initSentryWhenIdle = () => {
  if (isLocalhost) return;
  const start = () =>
    import("@sentry/react").then((Sentry) => {
      Sentry.init({
        dsn: "https://acee9f3192b38075d7716d63ac019e37@o4510785687846912.ingest.us.sentry.io/4510796252971008",
        sendDefaultPii: true,
        integrations: [Sentry.replayIntegration()],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        // Facebook/Instagram in-app browser tears down its Java bridge while JS is still running.
        ignoreErrors: [
          /Java object is gone/i,
          /Java exception was raised during method invocation/i,
          /Error invoking postMessage/i,
        ],
        denyUrls: [/iabjs:\/\//i, /iab_inner_frame/i],
      });
    });

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(start, { timeout: 4000 });
  } else {
    setTimeout(start, 2000);
  }
};

window.global || window;

const rootElement = document.getElementById("root");
if (rootElement && !isMarketingPath(window.location.pathname)) {
  rootElement.innerHTML = "";
}
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Never leave the page permanently hidden if React fails to mount.
setTimeout(() => {
  document.documentElement.classList.add("app-ready");
}, 5000);

initSentryWhenIdle();
